<template>
  <div class="listNotice">
    <div class="main_title1">
      <h3>公示公告</h3>
      <a href="/list/01510003">MORE+</a>
    </div>
    <div class="main_ul">
      <div class="link-container swiper-container" id="link">
        <div class="link-wrapper swiper-wrapper">
          <div
            class="link-slide swiper-slide"
            v-for="(item, index) in NoticeList"
            :key="index">
            <a target="_blank" :href="item.url && item.url !== '' ? item.url : `/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">{{ item.title | ellipsis}} </a>
          </div>
        </div>
        <!-- <div class="swiper-scrollbar"></div> -->
      </div>
    </div>  
  </div>
</template>

<script>
import Swiper from 'swiper'
import { articles} from '@/api/common'
export default {
  components: {

  },
  data() {
    return {
      NoticeList:[],
      pageSize: 20,
      pageNum: 1,
      channelUuid: '01510003',
    }
  },
  filters: {
    //超过100位显示 ...
    ellipsis: function(value) {
      if (!value) return ''
      if (value.length > 10) {
        return value.slice(0, 14) + '...'
      }
      return value
    },
  },

  mounted() {
    this.Notice()
  },

  methods: {
    Notice() {
      var _this = this
      let data = {
        entTApplicationUuid: _this.webId,
        channelUuid: _this.channelUuid,
        pageNum: _this.pageNum,
        pageSize: _this.pageSize
      }

      articles(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.NoticeList = data.rows
          this.$nextTick(() => {
            new Swiper('#link', {
              direction: 'vertical',
              autoHeight: true,
              speed: 2000,
              autoplay: 500,
              loop: true,
              // grabCursor: true, //手型
              slidesPerView: 6,
              spaceBetween: 0,
              observer: true,
              observeParents: true,
              observeSlideChildren: true
            })
          })
        }
      })
    },
  }

}


</script>

<style scoped>
.listNotice {
    width: 259px;
    height: auto;
    border: 1px solid #cccccc;
}

.listNotice .main_title1 {
    height: 39px;
    background-color: #eeeeee;
    border-bottom: #e8e8e8;
}

.main_title1 h3 {
    float: left;
    width: 116px;
    height: 36px;
    font-size: 20px;
    color: #ffffff;
    text-align: center;
    line-height: 36px;
    font-weight: normal;
    background-color: #0065bc;
    margin: 1px 0 0 1px;
}

.main_title1 a {
    float: right;
    color: #004e96;
    font-size: 14px;
    margin-right: 10px;
    line-height: 36px;
}
.main_ul {
    height: auto;
    padding: 10px 14px 8px;
}
.link-container{
    overflow: hidden;
    position: relative;
    height: 204px;
}
.link-slide{
  width: 331px;
  height: 34px;
  line-height: 34px;
  padding-left: 13px;
  background: url(../assets/image/gsqj_14.jpg) no-repeat;
  background-position: 2px center;
}
.link-slide a:hover{
  color: #0069ab;
}
#link .link-container .swiper-wrapper{
  -webkit-transition-timing-function: linear;    /*之前是ease-out*/
  -moz-transition-timing-function: linear;
  -ms-transition-timing-function: linear;
  -o-transition-timing-function: linear;
  transition-timing-function: linear;
  margin: 0 auto;
}
#link .link-container .swiper-wrapper a{
  -webkit-transition-timing-function: linear;    /*之前是ease-out*/
  -moz-transition-timing-function: linear;
  -ms-transition-timing-function: linear;
  -o-transition-timing-function: linear;
  transition-timing-function: linear;
}
.listNotice a{
  transition: all .3s linear;
}
</style>